import React from 'react';
import { Download } from 'lucide-react';

const ExportButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
  >
    <Download className="w-4 h-4" />
    <span>Export to Excel</span>
  </button>
);

export default ExportButton;

